import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path key='0' d='M0 0h24v24H0z' fill='none' />,
    <path key='1' d='M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' />,
  ],
  'TransportParking'
);

const TransportParkingIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportParkingIcon);
